import { createElement } from 'react'
import { FlagCell } from 'routes/shared/components'
import { createInWinImage } from 'shared/components/table/cellRenderers'

export const createColumns = () => [
  {
    Header: 'Team Name',
    accessor: 'teamName',
  },
  {
    Header: 'Logo',
    accessor: 'logo',
    Cell: createInWinImage,
  },
  {
    header: 'Sport',
    accessor: 'sport',
  },
  {
    Header: 'Members Count',
    accessor: 'athletesIds.length',
  },
  {
    Header: 'Jurisdiction',
    accessor: 'jurisdiction.logo',
    Cell: FlagCell,
  },
]
